const API_URL =   "https://admyracollections.au/csadmin/api/"
//const API_URL = 'https://admyracollections.studykee.com/csadmin/api/'
const DEFAULT_IMAGE = "/img/defaultimage.png";
const CATEGORIES = [];
const themesetting = {};
export default { API_URL, CATEGORIES, themesetting, DEFAULT_IMAGE };
